import { InjectionToken } from '@angular/core';

import { LegalDocumentsStore } from '../interfaces';

export const LEGAL_DOCUMENTS_STORE = new InjectionToken<LegalDocumentsStore>('LEGAL_DOCUMENTS_STORE');
